import { X } from 'lucide-react'
import { ReactNode } from 'react'

import { cn } from '@/lib/ui/style-helpers'

import { Button, ButtonProps } from './button'

type SplitButtonsProps = {
  children: ReactNode
  onPrimaryClick?: () => void
  onSecondaryClick?: () => void
  secondaryAriaLabel: string
} & Partial<Pick<ButtonProps, 'className' | 'aria-label' | 'size' | 'variant'>>

export const SplitButtons = ({
  children,
  onPrimaryClick,
  onSecondaryClick,
  secondaryAriaLabel,
  className,
  ...buttonsProps
}: SplitButtonsProps) => {
  const { 'aria-label': primaryAriaLabel, ...sharedProps } = buttonsProps

  return (
    <div className='flex gap-0.5'>
      <Button
        onClick={onPrimaryClick}
        aria-label={primaryAriaLabel}
        className={cn('rounded-none rounded-l', className)}
        {...sharedProps}
      >
        {children}
      </Button>
      <Button
        onClick={onSecondaryClick}
        aria-label={secondaryAriaLabel}
        className={cn('rounded-none rounded-r', className)}
        {...sharedProps}
      >
        <X size={16} />
      </Button>
    </div>
  )
}
